export const skillsData = [
  {
    category: "Data & Backend",
    skills: [
      { name: "SQL Server/SSIS", level: "expert" },
      { name: "PostgreSQL", level: "expert" },
      { name: "ETL/Data Pipelines", level: "expert" },
      { name: "Prefect", level: "familiar" },
      { name: "Pandas", level: "familiar" },
      { name: "Selenium", level: "familiar" },
    ],
  },
  {
    category: "Languages & Frameworks",
    skills: [
      { name: "JavaScript", level: "expert" },
      { name: "Python", level: "expert" },
      { name: "React", level: "expert" },
      { name: "Express", level: "expert" },
      { name: "C#", level: "familiar" },
      { name: "C++", level: "familiar" },
    ],
  },
  {
    category: "Tools & Web",
    skills: [
      { name: "Git", level: "expert" },
      { name: "CSS/HTML", level: "expert" },
      { name: "Bootstrap", level: "expert" },
      { name: "jQuery", level: "familiar" },
    ],
  },
];